import { render, staticRenderFns } from "./ConfiguracionAlarmas.vue?vue&type=template&id=b79db11e&"
import script from "./ConfiguracionAlarmas.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionAlarmas.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionAlarmas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b79db11e', component.options)
    } else {
      api.reload('b79db11e', component.options)
    }
    module.hot.accept("./ConfiguracionAlarmas.vue?vue&type=template&id=b79db11e&", function () {
      api.rerender('b79db11e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfiguracionAlarmas/ConfiguracionAlarmas.vue"
export default component.exports